import { INavData } from '@coreui/angular';

import { navigations } from 'src/app/routes';

/**
 * Auto create the url and generate the sidebar navigation. (for the admin)
 *
 * Careful: Please if you want to add a route, write it inside ./app/routes.ts
 */
const formatedNavigation = navigations.map((route): INavData => {
  route.url = '/' + route.path;
  return route;
});

export const navItems: INavData[] = [...formatedNavigation];
